import { createFileRoute } from '@tanstack/react-router'
import SettingsRunnersPage from '@/components/pages/Settings/team/SettingsRunnersPage/SettingsRunnersPage'

export const Route = createFileRoute('/$workspaceName/$environment/team-settings/runners')({
  component: RunnersSettingsRoute,
})

function RunnersSettingsRoute() {
  return <SettingsRunnersPage />
}
